import { ApiConstants } from '@epi-constants/actions';
import createReducer from '@epi-helpers/CreateReducer';

interface State {
  isLoading: string[];
  noPersistance: boolean;
}

interface Action {
  id: string;
  [key: string]: any;
}

export const getInitialState = (): State => ({
  isLoading: [],
  noPersistance: true
});

const AddId = (state: State, id: string): string[] => [...state.isLoading, id];

const RemoveId = (state: State, id: string): string[] => [
  ...(state.isLoading || []).filter(value => value !== id)
];

export default createReducer(getInitialState, {
  [`${ApiConstants.GET_RECEIPT_FOR_DEPOSIT}_REQUEST`]: (
    state: State,
    { id }: Action
  ) => ({
    isLoading: AddId(state, `depositOrder-${id}`)
  }),

  [`${ApiConstants.GET_RECEIPT_FOR_DEPOSIT}_SUCCESS`]: (
    state: State,
    { id }: Action
  ) => ({
    isLoading: RemoveId(state, `depositOrder-${id}`)
  }),

  [`${ApiConstants.GET_RECEIPT_FOR_DEPOSIT}_FAILURE`]: (
    state: State,
    { id }: Action
  ) => ({
    isLoading: RemoveId(state, `depositOrder-${id}`)
  })
});
